import { Box } from "@mui/material";
import OrientationSchedulePopup from "../../components/Recruiting/OrientationSchedule/OrientationSchedulePopup";
import OrientationScheduleTable from "../../components/Recruiting/OrientationSchedule/OrientationScheduleTable";

const OrientationSchedulePage = () => (
  <Box className="incidents-page">
    <OrientationSchedulePopup />
    <OrientationScheduleTable />
  </Box>
);

export default OrientationSchedulePage;
